<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        :name="'package' + index"
        v-for="(p, index) in applyVo.packVoList"
        :key="'package' + index"
      >
        <template slot="title">
          <div style="position:absolute;padding-left:10px">{{ receiveTypeFormatter(p.receiveType) }}</div>
          {{ $t('lang.confirmReceiveInfo.package') + (index + 1) }}
          <i :class="isActive('package' + index) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </template>
        <div class="filelist">
          <el-row class="rowheader">
            <el-col :span="6" style="text-align: left; padding-left: 15px">{{
                $t('lang.applyDetail.certType')
              }}
            </el-col>
            <el-col :span="6" style="text-align: center">{{ $t('lang.applyDetail.certName') }}</el-col>
            <el-col :span="6" style="text-align: center">{{ $t('lang.applyDetail.copyNumber') }}</el-col>
            <el-col :span="6" style="text-align: center">{{ $t('lang.applyDetail.operation') }}</el-col>
          </el-row>
          <el-row
            class="filerow"
            v-for="(item, index) in p.detailVoList"
            :key="'detail' + index"
          >
            <el-col :span="6" style="text-align: left; padding-left: 15px">{{
                certTypeNameFormatter(item.certTypeCode)
              }}
            </el-col>
            <el-col :span="6" style="text-align: center">{{
                isZh ? item.certChineseName : item.certEnglishName
              }}
            </el-col>
            <el-col
              :span="6"
              style="text-align: center; font-weight: bold; color: #a2100e">{{
                item.copyNumber
              }}
            </el-col>
            <el-col :span="6" style="text-align: center">
              <el-button size="mini" type="text" v-if="item.electronicVersionFile" @click="downloadElectronicVersionFile(item.electronicVersionFile)">{{ $t('lang.applyDetail.downloadElectronicVersionFile') }}
                <i class="icon iconfont icon-xiangxiajiantou-s"></i>
              </el-button>
            </el-col>
          </el-row>
          <div class="itemtotalinfo" v-if="p.receiveType === 'ENTRUST_ON_SITE'">
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.packageStatusName') }}
                <div class="iteminforesult">{{ packageStatusFormatter(p.packageStatus) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.issuedTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.issuedTime) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.expectedReceiveTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.expectedReceiveTime, 2) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.receiveTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.receiveTime) }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.principalName') }}
                <div class="iteminforesult">{{ p.principalName }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.principalRelation') }}
                <div class="iteminforesult">{{ p.principalRelation }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.principalMobile') }}
                <div class="iteminforesult">{{ p.principalMobile }}</div>
              </el-col>
            </el-row>
          </div>
          <div class="itemtotalinfo" v-else-if="p.receiveType === 'ON_SITE'">
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.packageStatusName') }}
                <div class="iteminforesult">{{ packageStatusFormatter(p.packageStatus) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.issuedTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.issuedTime) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.expectedReceiveTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.expectedReceiveTime, 2) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.receiveTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.receiveTime) }}</div>
              </el-col>
            </el-row>
          </div>
          <div class="itemtotalinfo" v-else>
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.packageStatusName') }}
                <div class="iteminforesult">{{ packageStatusFormatter(p.packageStatus) }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailStatusName') }}
                <div class="iteminforesult">{{ mailStatusFormatter(p.mailStatus) }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.mailSendTime') }}
                <div class="iteminforesult">{{ dateFormatter(p.receiveTime) }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailCompany') }}
                <div class="iteminforesult">{{ p.mailCompany }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailTrackingNo') }}
                <div class="iteminforesult">{{ p.mailTrackingNo }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.mailAreaTypeName') }}
                <div class="iteminforesult">{{ mailAreaTypeFormatter(p.mailAreaType) }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailArea') }}
                <div class="iteminforesult">{{ p.mailArea }}</div>
              </el-col>
              <el-col :span="6" style="text-align: center">
                {{ $t('lang.applyDetail.city') }}
                <div class="iteminforesult">{{ p.mailCity }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailConsignee') }}
                <div class="iteminforesult">{{ p.mailConsignee }}</div>
              </el-col>
              <el-col :span="4" style="text-align: center">
                {{ $t('lang.applyDetail.mailConsigneePhone') }}
                <div class="iteminforesult">{{ p.mailConsigneePhone }}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" style="text-align: left">
                {{ $t('lang.applyDetail.mailZipCode') }}
                  <div class="iteminforesult">{{ p.mailZipCode }}</div>
              </el-col>
              <el-col :span="18" style="text-align: center">
                {{ $t('lang.applyDetail.mailAddress') }}
                <el-tooltip class="item" effect="light" :content="p.mailAddress" placement="bottom">
                  <div class="iteminforesult mail-address">{{ p.mailAddress }}</div>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import languageType from '@/locales/languageType'
import { downloadFile, listDictByType } from '@/api/base'
import { mapGetters } from 'vuex'
import { formatDate } from '@/util/util.date'

export default {
  name: 'paperApplyDetail',
  props: {
    applyVo: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    }
  },
  mounted () {
    this.loadCertTypeDict()
    this.initActiveNames()
  },
  data () {
    return {
      certTypeDict: [],
      activeNames: []
    }
  },
  methods: {
    receiveTypeFormatter (val) {
      if (val === 'ON_SITE') {
        return this.$t('lang.confirmReceiveInfo.receiveType.onsite')
      } else if (val === 'ENTRUST_ON_SITE') {
        return this.$t('lang.confirmReceiveInfo.receiveType.entrustOnsite')
      } else if (val === 'EXPRESS_MAIL') {
        return this.$t('lang.confirmReceiveInfo.receiveType.expressMail')
      }
      return ''
    },
    isActive (name) {
      return this.activeNames.findIndex((item) => {
        return item === name
      }) > -1
    },
    loadCertTypeDict () {
      listDictByType({
        type: 'CERT_TYPE'
      }).then(res => {
        this.certTypeDict = res.data
      })
    },
    certTypeNameFormatter (val) {
      const dict = this.certTypeDict.filter(dict => dict.code === val)[0]
      if (dict) {
        return this.isZh ? dict.chineseName : dict.englishName
      }
      return ''
    },
    initActiveNames () {
      this.applyVo.packVoList.forEach((pack, index) => {
        this.activeNames.push('package' + index)
      })
    },
    packageStatusFormatter (val) {
      if (val === 'DRAFT') {
        return this.$t('lang.applyDetail.packageStatus.draft')
      } else if (val === 'CERT_BEING_ISSUED') {
        return this.$t('lang.applyDetail.packageStatus.certBeingIssued')
      } else if (val === 'CERT_ISSUED') {
        return this.$t('lang.applyDetail.packageStatus.certIssued')
      } else if (val === 'RECEIVED') {
        return this.$t('lang.applyDetail.packageStatus.received')
      }
      return ''
    },
    dateFormatter (val, type = 1) {
      return formatDate(val, type)
    },
    mailStatusFormatter (val) {
      if (val === 'NO_NEED') {
        return this.$t('lang.applyDetail.mailStatus.noNeed')
      } else if (val === 'NOT_SENT') {
        return this.$t('lang.applyDetail.mailStatus.notSent')
      } else if (val === 'SENT') {
        return this.$t('lang.applyDetail.mailStatus.sent')
      }
      return ''
    },
    mailAreaTypeFormatter (val) {
      if (val === 'DOMESTIC') {
        return this.$t('lang.applyDetail.mailAreaType.domestic')
      } else if (val === 'INTERNATIONAL') {
        return this.$t('lang.applyDetail.mailAreaType.international')
      } else if (val === 'HK_MACAO_TW') {
        return this.$t('lang.applyDetail.mailAreaType.hkMacaoTw')
      }
      return ''
    },
    downloadElectronicVersionFile (file) {
      downloadFile(file)
    }
  }
}
</script>

<style scoped>
/deep/ .el-collapse {
  border: none;
}

/deep/ .el-collapse-item {
  position: relative;
  margin-bottom: 25px;
}

/deep/ .el-collapse-item__header {
  background-color: #848484;
  color: #fff;
  text-align: center;
  display: block;
  border-left: 5px solid #a2100e;
  border-bottom: none;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
  position: relative;
}

/deep/ .el-collapse-item__header.is-active {
  background-color: #a2100e;
}

/deep/ .el-collapse-item__header i {
  font-size: 12px;
  margin-left: 15px;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/ .el-icon-arrow-right::before {
  content: "";
}

/deep/ .el-collapse-item__wrap {
  border: none;
}

.requestinfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

.requestno {
  color: #a2100e;
}

.requestdate {
  color: #6a6c71;
}

.itemtitle {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
  color: #707070;
}

.filelist .filerow:nth-child(even) {
  background: #ededed;
}

/deep/ .el-button--text {
  color: #606266;
}

/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;
}

/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}

.totalinfo {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfo span {
  color: #a2100e;
}

.totalinfoext {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfoext .extred {
  color: #a2100e;
  display: block;
  line-height: 50px;
}

.flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.itemtotalinfo {
  background: #ededed;
  padding: 15px;
  font-weight: bold;
  font-size: 12px;
  color: #5b5b5b;
  text-align: left;
}

.itemtotalinfo .iteminforesult {
  font-size: 16px;
  color: #a2100e
}

.mail-address {
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
